import React from 'react';
import {
    BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Cell
  } from 'recharts';
  
import CustomTooltip from './tooltip';
import './line.scss';

const CustomizedAxisTick = (props) => {
    const {x, y, fontSize, payload} = props;

    const label = payload.value.split('\n');
	 
    return (
        <g className="recharts-layer recharts-cartesian-axis-tick x-axis">
            {label.map((val, i) => {
                return (
                    <text key={`${val}${i}`} x={x} y={y} dy={16*(i+1)} textAnchor="middle" className="recharts-text recharts-cartesian-axis-tick-value recharts-text--custom" fontSize={fontSize} fill="#485465">{val.trim()}</text>
                );
            })};
        </g>
    );
};


const Chart = ({ height = 250, ...props}) => {
    let fontSize = 13;
    let left = -12;
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 400) {
        fontSize = 8;
        left = -28;
    }

    return (
        <ResponsiveContainer width="99%" height={height}>
            <BarChart
                maxBarSize={38}
                margin={{top: 0, right: 0, left: left, bottom: 0}}
                data={props.data}>
                    <CartesianGrid vertical={false} stroke="#d5dadd" />
                    <XAxis stroke="#d5dadd" dataKey="name" tickLine={false} tick={<CustomizedAxisTick fontSize={fontSize} />} interval={0} />
                    <YAxis stroke="#d5dadd" tickLine={false} tick={{ fill: '#485465', fontSize: fontSize }} />
                    <Tooltip content={<CustomTooltip valueLabel={props.valueLabel} unit={props.unit} total={props.total} totalLabel={props.totalLabel} />} cursor={false} />
                    <Bar dataKey="data" radius={[3, 3, 0, 0]}>
                        {props.dataKeys && props.dataKeys.map(barKey => {
                            return (
                                <Cell key={barKey.key} fill={barKey.background} />
                            );
                        })}
                    </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default Chart;